import { render, staticRenderFns } from "./wizardDataUpload.vue?vue&type=template&id=f5988e54&scoped=true&"
import script from "./wizardDataUpload.vue?vue&type=script&lang=js&"
export * from "./wizardDataUpload.vue?vue&type=script&lang=js&"
import style0 from "./wizardDataUpload.vue?vue&type=style&index=0&id=f5988e54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5988e54",
  null
  
)

export default component.exports